import { TEXT } from "../configs/text"
import { AssessmentAnswer } from "./assessment"
import { Session, SessionPoint } from "./session"

export interface ClassItemProps {
    id: number
    name: string
    start_date: number
    end_date: number
    start_time: string
    end_time: string
    state: ClassStatus
    topic?: string | null
    subject_name?: string | null
    unit_name?: string | null
    lesson_name?: string | null
    system: string
}

export interface ClassDetails extends ClassItemProps {
    access_code: string
    teacher_name: string
    assistant_name: string | null
    groups: ClassGroupInfo[]
    students?: ClassStudentInfo[]
    student_group_id?: number | null
    lockScreen?: boolean
    allowRaiseHand?: boolean
    expiredTime?: number
}

export enum ClassStatus {
    not_started = 'not_started',
    on_going = 'on_going',
    finished = 'finished',
}

export enum ClassRequestStatus {
    rejected = 0,
    approved = 1
}

export const classStatusMap = {
    [ClassStatus.not_started]: TEXT.not_started,
    [ClassStatus.on_going]: TEXT.on_going,
    [ClassStatus.finished]: TEXT.finished,
}

export interface ClassGroupInfo {
    id: number
    name: string
    students: ClassStudentInfo[] | null
    point?: SessionPoint
}

export interface ClassStudentInfo {
    id: number
    username: string
    full_name: string
    group_id: number | null
    status: AttendStatus
    connected?: boolean
    point?: SessionPoint
    quizQuestion?: AssessmentAnswer[]
    isSubmitLecture?: boolean
    lectureQuestions?: AssessmentAnswer[]
    avatar?:string
}

export interface StudentChangeGroup {
    studentId: number
    username: string
    groupId: number | null
}

export enum ClassViewType {
    student = 'students',
    group = 'groups',
    leaderboard = 'leaderboard'
}
export const classViewTypeMap = {
    [ClassViewType.student]: TEXT.students,
    [ClassViewType.group]: TEXT.groups,
    [ClassViewType.leaderboard]: TEXT.leaderboard,
}

export enum AttendStatus {
    waiting = 'waiting',
    left = 'left',
    attended = 'attended',
    absent = 'absent'
}

export enum ClassViewMode {
    teaching = 'Teaching',
    management = 'Management'
}

export const classViewModeMap = {
    [ClassViewMode.teaching]: TEXT.teaching,
    [ClassViewMode.management]: TEXT.management
}
export interface PracticeQuizState {
    [Session.practice]?: boolean
    [Session.quiz]?: boolean
}

export interface RankedGroup extends ClassGroupInfo {
    rank: number;
}

export interface RankedStudent extends ClassStudentInfo {
    rank: number;
}